module.exports = __webpack_public_path__ + "img-createrelease.f4393f68b46974e52f9794497ebaa202.hashedasset.svg";